<template>
  <div class="columns is-marginless is-paddingless section section-details">
    <div class="column is-10" v-if="emplacement">
      <div class="card" id="caracteristiques">
        <header class="header-card">
          <p>
            {{ $t('adresseEmplacement.caracteristique') }}
          </p>
        </header>
        <div class="card-content">
          <header-emplacement :emplacement="emplacement">
          </header-emplacement>
          <div class="columns">
            <div class="column is-2">
              <b-field :label="$t('adresseEmplacement.domaineConsultation')"
                      custom-class="has-text-link">
                <p class="has-text-default"
                  v-if="emplacement.emplacementAdresse.domaine === publicValue">
                  {{ $t('adresseEmplacement.public') }}
                </p>
                <p class="has-text-default" v-else>
                  {{ $t('adresseEmplacement.prive') }}
                </p>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('adresseEmplacement.lineaireFacadeConsultation')"
                      custom-class="has-text-link">
                <p class="has-text-default">{{emplacement.emplacementAdresse.lineaireFacade}}</p>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('adresseEmplacement.numeroParcelleConsultation')"
                      custom-class="has-text-link">
                <p class="has-text-default">{{emplacement.emplacementAdresse.numeroParcelle}}</p>
              </b-field>
            </div>
          </div>
        </div>
      </div>
      <div class="card mgt-20px" id="adresse">
        <header class="header-card">
          <p>
            {{ $t('adresseEmplacement.adresse') }}
          </p>
        </header>
        <div class="card-content">
          <adresse-cadastrale :adresseCadastraleInformation="emplacement.adresseCadastrale"
                              :showTitle="false">
          </adresse-cadastrale>
        </div>
      </div>
      <div class="card mgt-20px" id="pj">
        <header class="header-card">
          <p>
            {{ $t('adresseEmplacement.pj') }}
          </p>
        </header>
        <div class="card-content">
          <app-pieces-jointes :checkPermissions=checkPermissions(permEmplacement.maj)
                              readOnly
                              deletable
                              autoSave>
          </app-pieces-jointes>
        </div>
      </div>
    </div>
    <div class="column is-2">
      <div class="is-fixed mgt-20px">
        <dots-menu :steps="steps">
        </dots-menu>
        <information-create-update-user class="mgr-20px" :data="emplacement">
        </information-create-update-user>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { EMPLACEMENT } from '@/configuration/gabed/permissionsGabedConf';
import headerEmplacement from '@/components/gabed/emplacement/headerConsultationEmplacement';
import adresseCadastrale from '@/components/gabed/emplacement/adresseConsultationEmplacement';
import { PUBLIC, PRIVE } from '@/configuration/gabed/emplacement/emplacementAdresseConf';
import PiecesJointes from '@/components/general/piecesJointes';
import dotsMenu from '@/components/general/dotsMenu';
import InformationCreateUpdateUser from '@/components/general/informationCreateUpdateUser';

const permissions = createNamespacedHelpers('permissions');

export default {
  props: {
    emplacement: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      permEmplacement: EMPLACEMENT,
      publicValue: PUBLIC,
      priveValue: PRIVE,
      steps: [
        {
          name: this.$i18n.t('detailEmplacement.steps.caracteristiques'),
          ref: '#caracteristiques',
          active: true,
        },
        {
          name: this.$i18n.t('detailEmplacement.steps.adresse'),
          ref: '#adresse',
          active: false,
        },
        {
          name: this.$i18n.t('detailEmplacement.steps.pj'),
          ref: '#pj',
          active: false,
        },
      ],
    };
  },
  components: {
    headerEmplacement,
    adresseCadastrale,
    appPiecesJointes: PiecesJointes,
    dotsMenu,
    InformationCreateUpdateUser,
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
  },
};
</script>
